import { render, staticRenderFns } from "./StepRelatorio.vue?vue&type=template&id=8376a738&scoped=true"
import script from "./StepRelatorio.vue?vue&type=script&lang=js"
export * from "./StepRelatorio.vue?vue&type=script&lang=js"
import style0 from "./StepRelatorio.vue?vue&type=style&index=0&id=8376a738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8376a738",
  null
  
)

export default component.exports